export default function RowMicrosoftMessage ({ item }) {

  return (
    <>
      <div dangerouslySetInnerHTML={{__html: item.body.content}} className="microsoft-message"></div>
    </>
  );
}
